var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-table-row ui-p-4 ui-pl-8 ui-flex ui-flex-row c-bg-white ui-w-full",class:{
    'ui-h-16': !_vm.rowVariableHeight,
    'hover:c-bg-gray-100': _vm.hoverable,
    'ui-cursor-default': !_vm.clickable,
    'ui-cursor-pointer': _vm.clickable,
  },style:({ 'word-break': 'break-word' }),on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }